module.exports = __webpack_public_path__ + "static/img/a017.1998f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a017.jpg
// module id = CQSz
// module chunks = 0